import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component to add robots noindex meta tag to the page head.
 * Use this on pages that should not be indexed by search engines.
 */
const RobotsNoIndex: React.FC = () => {
  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
};

export default RobotsNoIndex; 